export const navFr = {
  main: "Navigation principale",
  tabs: "Onglets",
  dashboard: "Tableau de bord",
  home: "Accueil",
  call: "Appeler",
  my_calls: "Mes appels", // GAVION my-calls
  leads: "Compagnies",
  contacts: "Contacts",
  deals: "Deals",
  tasks: "Tâches",
  meetings: "Réunions",
  email: "Courriels",
  drafts: "Brouillons", // GAVION ai-email
  reports: "Rapports",
  recruiting: "Recrutement", // GAVION recruiting
  training: "Formation",
  settings: "Paramètres",
  more: "Plus",
  in_session: "En session",
  call_in_progress: "Appel en cours",
  toggle_sidebar: "Afficher ou masquer le menu",
  user_menu: "Menu du compte",
  my_profile: "Mon profil",
  configuration: "Configuration",
  import_data: "Importer des données",
  coming_soon: "Bientôt disponible",
  coming_soon_hint: "Cette page arrive bientôt.",
  integrations: "Intégrations",
};
